module.exports = __webpack_public_path__ + "img/sus-kf.fa39e6e.svg";